import React from 'react';
import PropTypes from 'prop-types';

import ErrorPopup from "../components/ErrorPopup";
import { injectIntl } from "react-intl";

const ErrorPage = ({ intl, errorMessage, additionalErrorMessage }) => {
    return (
        <ErrorPopup
            level={intl.formatMessage({ id: 'criticalError' })}
            originalError={errorMessage}
            additionalInfo={additionalErrorMessage}
        />
    );
};

ErrorPage.propTypes = {
    errorMessage: PropTypes.string,
    additionalErrorMessage: PropTypes.string,
};

ErrorPage.defaultProps = {
    errorMessage: undefined,
    additionalErrorMessage: undefined,
};

export default injectIntl(ErrorPage);
